import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  downloadRainHistoryCsv,
  fetchFarmRetreats,
  importRainHistoryCsv,
} from "redux/operations";
import { RootState } from "redux/reducers";
import RainHistoryPage from "./rainHistoryPage";

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
type RainHistoryContainerProps = StateProps & DispatchProps;

function RainHistoryContainer({
  downloadRainHistoryCsvDispatch,
  fetchFarmRetreatsDispatch,
  importRainHistoryCsvDispatch,
  retreats,
}: RainHistoryContainerProps) {
  useEffect(() => {
    fetchFarmRetreatsDispatch();

    // We want to run this only once on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDownloadRainHistoryCsv = async (
    ...params: Parameters<typeof downloadRainHistoryCsv>
  ) => {
    await Promise.resolve(downloadRainHistoryCsvDispatch(...params));
  };

  const handleImportRainHistoryCsv = async (
    ...params: Parameters<typeof importRainHistoryCsv>
  ) => {
    await Promise.resolve(importRainHistoryCsvDispatch(...params));
  };

  return (
    <RainHistoryPage
      downloadRainHistory={handleDownloadRainHistoryCsv}
      importRainHistory={handleImportRainHistoryCsv}
      retreats={retreats}
    />
  );
}

const mapStateToProps = (state: RootState) => ({
  retreats: state.pasture.farmRetreats,
});

const mapDispatchToProps = {
  downloadRainHistoryCsvDispatch: downloadRainHistoryCsv,
  fetchFarmRetreatsDispatch: fetchFarmRetreats,
  importRainHistoryCsvDispatch: importRainHistoryCsv,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(RainHistoryContainer);
